<template>
    <div class="page-config-live-data">
        <div class="col-md-3 col-lg-2 d-md-block bg-light sidebar">
            <NavPlantsSidebar v-if="plantsLoaded" v-bind="currentPlantsProperties" 
                v-on:setPlant="setPlant"></NavPlantsSidebar>
        </div>
        <div class="col-md-9 ms-sm-auto col-lg-10">
            <template v-if="this.currentPlant">
                <component :is="currentTabComponent" v-bind="currentProperties"></component>
            </template>
        </div>
    </div>
</template>

<script>
    
import AlarmmessagesForPlant from '@/components/analyse/AlarmmessagesForPlant.vue'
import NavPlantsSidebar from '@/components/navs/NavPlantsSidebar.vue'
export default {
    name: 'AlarmmessagesForPlants',
    components: {
        AlarmmessagesForPlant,
        NavPlantsSidebar
    },
    data() {
        return {
            currentPlant: '',
            currentTabComponent: ''
        }
    },
    methods: {
        setPlant(plant){
            console.log('entry setPlant')
            this.currentPlant = plant
            this.currentTabComponent = 'AlarmmessagesForPlant'
            console.log('exit setPlant')
        }     
    },
    computed:{
        plantsLoaded(){
            if(this.$store.getters.getPlants){
                return true
            }
            return false
        },
        organisation(){
            return this.$store.getters.getOrganisation
        },
        
        currentProperties(){
            return {plant: this.currentPlant}
        },
        currentPlantsProperties(){
                return {plants: this.$store.getters.getPlants
                    ,showPlantComponents: false
                    ,editPlantComponents: false
                    ,editPlants: false}
            },
    }
}
</script>
